import type { ThemeDefinition } from "vuetify";

export const staticPrimaryColor = "#2563EB";
export const staticPrimaryDarkenColor = "#1D4ED8";

export const themes: Record<string, ThemeDefinition> = {
  light: {
    dark: false,
    colors: {
      primary: staticPrimaryColor,
      "on-primary": "#fff",
      "primary-darken-1": "#1D4ED8",
      secondary: "#64748B",
      "on-secondary": "#fff",
      "secondary-darken-1": "#475569",
      success: "#16A34A",
      "on-success": "#fff",
      "success-darken-1": "#15803D",
      info: "#0EA5E9",
      "on-info": "#fff",
      "info-darken-1": "#0284C7",
      warning: "#F59E0B",
      "on-warning": "#fff",
      "warning-darken-1": "#D97706",
      error: "#EF4444",
      "on-error": "#fff",
      "error-darken-1": "#DC2626",
      background: "#F8FAFC",
      "on-background": "#0F172A",
      surface: "#fff",
      "on-surface": "#0F172A",
      "grey-50": "#F8FAFC",
      "grey-100": "#F1F5F9",
      "grey-200": "#E2E8F0",
      "grey-300": "#CBD5E1",
      "grey-400": "#94A3B8",
      "grey-500": "#64748B",
      "grey-600": "#475569",
      "grey-700": "#334155",
      "grey-800": "#1E293B",
      "grey-900": "#0F172A",
      "grey-light": "#F8FAFC",
      "perfect-scrollbar-thumb": "#CBD5E1",
      "skin-bordered-background": "#fff",
      "skin-bordered-surface": "#fff",
      "expansion-panel-text-custom-bg": "#F8FAFC",
    },

    variables: {
      "code-color": "#d400ff",
      "overlay-scrim-background": "#0F172A",
      "tooltip-background": "#0F172A",
      "overlay-scrim-opacity": 0.5,
      "hover-opacity": 0.06,
      "focus-opacity": 0.1,
      "selected-opacity": 0.08,
      "activated-opacity": 0.16,
      "pressed-opacity": 0.14,
      "dragged-opacity": 0.1,
      "disabled-opacity": 0.4,
      "border-color": "#0F172A",
      "border-opacity": 0.1,
      "table-header-color": "#F1F5F9",
      "high-emphasis-opacity": 0.9,
      "medium-emphasis-opacity": 0.7,
      "switch-opacity": 0.2,
      "switch-disabled-track-opacity": 0.3,
      "switch-disabled-thumb-opacity": 0.4,
      "switch-checked-disabled-opacity": 0.3,
      "track-bg": "#E2E8F0",

      // Shadows
      "shadow-key-umbra-color": "#0F172A",
      "shadow-xs-opacity": 0.06,
      "shadow-sm-opacity": 0.08,
      "shadow-md-opacity": 0.1,
      "shadow-lg-opacity": 0.12,
      "shadow-xl-opacity": 0.14,
    },
  },
  dark: {
    dark: true,
    colors: {
      primary: staticPrimaryColor,
      "on-primary": "#fff",
      "primary-darken-1": "#1D4ED8",
      secondary: "#64748B",
      "on-secondary": "#fff",
      "secondary-darken-1": "#475569",
      success: "#22C55E",
      "on-success": "#fff",
      "success-darken-1": "#16A34A",
      info: "#38BDF8",
      "on-info": "#fff",
      "info-darken-1": "#0EA5E9",
      warning: "#FBBF24",
      "on-warning": "#fff",
      "warning-darken-1": "#F59E0B",
      error: "#F87171",
      "on-error": "#fff",
      "error-darken-1": "#EF4444",
      background: "#0F172A",
      "on-background": "#E2E8F0",
      surface: "#1E293B",
      "on-surface": "#E2E8F0",
      "grey-50": "#0F172A",
      "grey-100": "#1E293B",
      "grey-200": "#1E293B",
      "grey-300": "#334155",
      "grey-400": "#475569",
      "grey-500": "#64748B",
      "grey-600": "#94A3B8",
      "grey-700": "#CBD5E1",
      "grey-800": "#E2E8F0",
      "grey-900": "#F1F5F9",
      "grey-light": "#1E293B",
      "perfect-scrollbar-thumb": "#334155",
      "skin-bordered-background": "#1E293B",
      "skin-bordered-surface": "#1E293B",
    },
    variables: {
      "code-color": "#d400ff",
      "overlay-scrim-background": "#020617",
      "tooltip-background": "#F1F5F9",
      "overlay-scrim-opacity": 0.6,
      "hover-opacity": 0.06,
      "focus-opacity": 0.1,
      "selected-opacity": 0.08,
      "activated-opacity": 0.16,
      "pressed-opacity": 0.14,
      "dragged-opacity": 0.1,
      "disabled-opacity": 0.4,
      "border-color": "#E2E8F0",
      "border-opacity": 0.1,
      "table-header-color": "#334155",
      "high-emphasis-opacity": 0.9,
      "medium-emphasis-opacity": 0.7,
      "switch-opacity": 0.4,
      "switch-disabled-track-opacity": 0.4,
      "switch-disabled-thumb-opacity": 0.8,
      "switch-checked-disabled-opacity": 0.3,
      "track-bg": "#1E293B",

      // Shadows
      "shadow-key-umbra-color": "#020617",
      "shadow-xs-opacity": 0.16,
      "shadow-sm-opacity": 0.18,
      "shadow-md-opacity": 0.2,
      "shadow-lg-opacity": 0.22,
      "shadow-xl-opacity": 0.24,
    },
  },
};

export default themes;
